import qs from 'qs';
import * as constType from '../constants/actionsTypes';
import {
  apiGetAddressBook,
  apiPostPlaceOrder,
  // apiPostUpdateDeliveryAddress,
} from './testJsonApi';

const shoppingInfoMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case 'MID_GET_ADDRESS_BOOK': {
      apiGetAddressBook('get')
        .then((res) => {
          const response = JSON.parse(res.data);
          if (response.rtnCode === 1 && response.rtnMsg === 'Success') {
            store.dispatch({
              type: constType.GET_ADDRESS_BOOK,
              payload: response.addresshistory,
            });
          }
        })
        .catch((err) => {
          console.log('error', err);
        });

      return next(action);
    }
    case 'MID_POST_PLACE_ORDER': {
      const postRequest = qs.stringify(action.payload);
      store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: true });
      apiPostPlaceOrder('post', postRequest)
        .then((res) => {
          const response = JSON.parse(res.data);
          const { rtnCode, rtnMsg, goUrl } = response;

          if (rtnCode === 1) {
            // 成立訂單成功轉導
            console.log(rtnCode, rtnMsg, goUrl);
            window.location.href = goUrl;
            return false;
          }

          store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: false });
          console.log(rtnCode, rtnMsg, goUrl);
          store.dispatch({
            type: constType.UPDATE_API_RESPONSE,
            payload: response,
          });
          return true;
        })
        .catch((err) => {
          console.log('error', err);
          store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: false });
        });

      return next(action);
    }
    // case 'MID_POST_UPDATE_DELIVERY_ADDR': {

    //   const postRequest = qs.stringify(action.payload);
    //   // store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: true });
    //   apiPostUpdateDeliveryAddress('post', postRequest)
    //     .then((res) => {

    //       let response = JSON.parse(res.data);
    //       // 設定來源是從更新訂購人樓層資訊來的
    //       response.source = 'update Orderer floor and elevator';
    //       store.dispatch({
    //         type: constType.UPDATE_API_RESPONSE,
    //         payload: response,
    //       });
    //     })
    //     .catch((err) => {

    //     })

    //     return next(action);
    // }
    // case 'MID_POST_UPDATE_DELIVERY_ADDR_FOR_FREIGHT_CHARGE': {

    //   const postRequest = qs.stringify(action.payload);
    //   // store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: true });
    //   apiPostUpdateDeliveryAddress('post', postRequest)
    //     .then((res) => {

    //       let response = JSON.parse(res.data);
    //        // 登高狀態 設定來源是從更新收件人樓層來源資訊來的
    //       response.source = 'update freight charge floor and elevator';
    //       store.dispatch({
    //         type: constType.UPDATE_API_RESPONSE,
    //         payload: response,
    //       });
    //     })
    //     .catch((err) => {

    //     })

    //     return next(action);
    // }
    default:
      return next(action);
  }
};

export default shoppingInfoMiddleware;
